import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

import { TimeFormatService } from '../services/time-format.service';

@Pipe({
  name: 'customDate',
  standalone: true,
  pure: false, // Required since we depend on tenant settings that can change
})
export class CustomDatePipe implements PipeTransform {
  constructor(private timeFormatService: TimeFormatService) {}

  transform(value: Date | string, formatType: 'time' | 'dateTime' | 'shortDateTime' | 'date' = 'dateTime'): string {
    if (!value) return '';

    // Ensure we have a valid moment object
    const momentDate = moment(value);
    if (!momentDate.isValid()) {
      return 'Invalid Date';
    }

    // Get format from service, with robust fallback
    let format: string;

    if (!this.timeFormatService.isReady()) {
      // Fall back to default 12-hour format while loading
      const defaultFormats = {
        time: 'h:mm a',
        dateTime: 'MMM D yyyy h:mm a',
        shortDateTime: 'M/D/yyyy h:mm a',
        date: 'MMM D yyyy',
      };
      format = defaultFormats[formatType] || defaultFormats.dateTime;
    } else {
      // Service is ready, get the format
      format = this.timeFormatService.getFormat(formatType);

      // Fallback if format is somehow invalid
      if (!format) {
        const defaultFormats = {
          time: 'h:mm a',
          dateTime: 'MMM D yyyy h:mm a',
          shortDateTime: 'M/D/yyyy h:mm a',
          date: 'MMM D yyyy',
        };
        format = defaultFormats[formatType] || defaultFormats.dateTime;
      }
    }

    return momentDate.format(format);
  }
}
